
import { Options, mixins } from 'vue-class-component'
import ScanArea from '@/components/svg/ScanArea.vue'
import BarcodeLabel from '@/components/BarcodeLabel.vue'
import { ADD_TRACKING, FETCH_BARCODE, SAVE_SCANNED_BARCODES } from '@/store/actions'
import { IBarcode, IProject, ITrackingRequestBody } from 'smartbarcode-web-core/src/utils/types/index'
import MultipleBarcodeScanMixin from '@/components/mixins/MultipleBarcodeScanMixin.vue'
import { tracking } from '@/utils/api'
import BarcodeSymbologiesSelection from '@/components/BarcodeSymbologiesSelection.vue'
import { cloneDeep } from 'lodash'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import SelectionCameraPopup from '@/components/dialog/SelectionCameraPopup.vue'
import BarcodeNotificationDialog from '@/components/dialog/BarcodeNotificationDialog.vue'
import IconSwitch from '@/components/svg/IconSwitch.vue'
import IconInfo from '@/components/svg/IconInfo.vue'

@Options({
  components: {
    ScanArea,
    BarcodeLabel,
    BarcodeSymbologiesSelection,
    IconSwitch,
    IconInfo,
    SelectionCameraPopup,
    BarcodeNotificationDialog,
  },
  name: 'BulkTracking',
})
export default class MultipleBarcodeScan extends mixins(MultipleBarcodeScanMixin) {
  loading = false
  requestBody = {} as ITrackingRequestBody
  nextSelectTrackingPointName = ''
  isReadyToScan = true

  get barcode(): IBarcode {
    return this.$store.state.barcode.barcode
  }

  removeScannedBarcode(bcId: string) {
    this.scannedBarcodeList = this.scannedBarcodeList.filter((b: IBarcode) => b.id !== bcId)
    this.barcodes = this.barcodes.filter((b: IBarcode) => b.id !== bcId)
    const ids = this.requestBody?.barcodeIds as string[]
    if (ids) {
      const idx = ids.indexOf(bcId)
      if (idx !== -1) ids.splice(idx, 1)
    }
    const updated = { ...this.barcodesWithNotifications }
    delete updated[bcId]
    this.barcodesWithNotifications = updated
  }

  async created() {
    this.isForcedHideMultipleScan = true
    if (!this.$store.state.barcode.barcode) {
      await this.$store.dispatch(FETCH_BARCODE, {
        id: this.$route.params.barcodeId,
        trackingNumber: this.trackingNumberFromPath,
        externalId: this.externalIdFromPath,
        path: this.queryPath,
      })
    }
    this.nextSelectTrackingPointName = this.$route.params.nextTrackName
    this.requestBody = JSON.parse(localStorage.tempRequestForMultipleBarcodeScan)
    this.scannedBarcodeList.push(cloneDeep(this.barcode))
  }

  async beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    await this.onLeaveGuard(to, from, next)
  }

  get bulkUpdateOperationLimitCount() {
    const project = this.$store.state.project.details as IProject
    const projectBarcode = project.barcodeTypes?.[this.$store.getters.barcodeType]
    return projectBarcode?.bulkUpdateOperationLimitCount
  }

  addBarcode(barcode: string) {
    ;(this.requestBody?.barcodeIds as string[]).push(barcode)
  }

  async validateBarcode(resultScanned: IBarcode) {
    const currentProjectId = this.$store.state.project.details.id
    const scannedBCProjectId = resultScanned.projectId
    if (currentProjectId !== scannedBCProjectId) {
      throw this.$t('scanned_barcode_not_same_project')
    }

    const { barcodeType } = resultScanned
    if (!barcodeType) {
      throw this.$t('barcode not activated')
    }
    const data = {
      barcodeId: this.barcode?.id,
      barcodeIds: [resultScanned?.id],
      trackingData: this.requestBody.trackingData,
      selectedNextTrackpoint: this.nextSelectTrackingPointName,
      isDryRun: true,
    }

    await tracking(data)
  }

  forward() {
    this.$store.dispatch(SAVE_SCANNED_BARCODES, [...this.barcodes])
    this.$router.push({
      name: 'scanned-barcode-list',
      params: {
        title: this.$t('bulk_tracking_read_result'),
        operation: ADD_TRACKING,
        extParams: JSON.stringify({
          trackingData: this.requestBody.trackingData,
          selectedNextTrackpoint: this.nextSelectTrackingPointName,
        }),
      },
    })
  }
}
